import c from './feedback-manager.module.scss';
import { Tag, Icon } from '@monash/portal-react';
import { PRIORITY_TAGS, FEEDBACK_STATUS } from './constants';

const FeedbackItem = ({ item, index, setSelectedID }) => {
  const timeAgo = (prevDate) => {
    const diff = Number(new Date()) - prevDate;
    const minute = 60 * 1000;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    switch (true) {
      case diff < minute:
        return Math.round(diff / 1000) + 'seconds ago';
      case diff < hour:
        return Math.round(diff / minute) + ' minutes ago';
      case diff < day:
        return Math.round(diff / hour) + ' hours ago';
      case diff < month:
        return Math.round(diff / day) + ' days ago';
      case diff >= month:
        return new Date(prevDate).toLocaleDateString();
      default:
        return '';
    }
  };

  const handleKeyDown = (e) => {
    if (e.code === 'Enter') {
      setSelectedID(`${item.id}`);
    }
  };

  return (
    <tr className={c.tr}>
      <td className={c.id}>{item.displayID}</td>
      <td className={c.appName}>{item.app}</td>
      <td className={c.appArea}>{item.area}</td>
      <td>{timeAgo(item.createdAt)}</td>
      <td>{FEEDBACK_STATUS[item.status] ?? 'New'}</td>
      <td>{item.reason}</td>
      <td>
        {PRIORITY_TAGS[item.priority] ? (
          <Tag
            text={PRIORITY_TAGS[item.priority]?.label}
            color={PRIORITY_TAGS[item.priority]?.colour}
            disabled={false}
          />
        ) : null}
      </td>
      <td>
        {item.lastEdit ? new Date(item.lastEdit).toLocaleDateString() : ''}
      </td>
      <td className={c.actionMenu}>
        <div
          className={c.arrow}
          onClick={() => setSelectedID(`${item.id}`)}
          tabIndex="0"
          onKeyDown={(e) => handleKeyDown(e)}
        >
          <Icon.ArrowRight key={item.displayID} />
        </div>
      </td>
    </tr>
  );
};

export default FeedbackItem;
